// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"952c1fbf","142":"0f20e368","174":"a36beb73","264":"f3b9e874","276":"386fce85","401":"1f7f1b00","422":"7e6c1a57","453":"944b34be","527":"24588ad7","734":"0a342f2c","791":"73e53367","797":"7d8c7f0c"}[chunkId] + ".chunk.js";
};